import React from 'react';

import { useTranslation } from '../../../../../hooks';
import { RewardsTabs } from '../../../../../enums';
import { T } from '../../../../../constants';

interface RewardsDetailedPopupTabsProps {
  activeTab: RewardsTabs;
  onTabChange: (tab: RewardsTabs) => void;
}

export const RewardsDetailedPopupTabs: React.FC<RewardsDetailedPopupTabsProps> = ({ activeTab, onTabChange }) => {

  const t = useTranslation();

  return (
    <div className="rewards-tab-wrp">
      <div className={`rewards-tab ${activeTab === RewardsTabs.Progress ? 'active' : ''}`} onClick={() => onTabChange(RewardsTabs.Progress)}>
        {t(T.PROGRESS)}
      </div>
      <div className={`rewards-tab ${activeTab === RewardsTabs.Rules ? 'active' : ''}`} onClick={() => onTabChange(RewardsTabs.Rules)}>
        {t(T.RULES)}
      </div>
    </div>
  );
};
